import React, {Component} from 'react';
import PropTypes from 'prop-types';
import NavigationLink from '../NavigationLink/NavigationLink';
import { NavLink } from 'react-router-dom';
import LocalizedStrings from 'react-localization';
import { SetComponentLanguage } from '../../../helpers';
import en from './locales/en.json';
import fr from './locales/fr.json';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class PatronNavigation extends Component {
	constructor(props) {
		super(props);
		this.state = {
            isLegalOpen: false,
		}
    }


	toggleLanguage = (e) => {
		e.preventDefault();
		const lang = e.target.innerHTML === 'English' ? 'en' : 'fr';
		localStorage.setItem('showtix4u-lang', lang);
		window.location.reload()
	}
	
	toggleReprintOrder = () => {
		this.props.toggleNav();
		this.props.toggleReprintOrder(true);
	}

	makeDonation = () => {
		this.props.toggleNav();
		this.props.makeDonation();
	}

	renderMakeDonation = () => {
		if((this.props.location.pathname.indexOf('/events') !== -1 || this.props.location.pathname.indexOf('/event-details') !== -1) && this.props.client && this.props.client.donation) {
            return (
                <li className='showtix-navigation__item'>
                    <button className={"showtix-navigation__link"}
                        onClick={this.makeDonation}>
                        {strings.makeDonation}
                    </button>
                </li>
            );
        } else {
            return null;
        }
	}

	toggleSubnav = () => {
        this.setState({
            isLegalOpen: !this.state.isLegalOpen,
        });
    }
    

	render() {
		return (
			<div className="showtix-navigation__patron">
				<ul className="showtix-navigation__list">
					<li className='showtix-navigation__item'>
						<NavLink className={"showtix-navigation__link"}
							to="#"
							onClick={this.toggleReprintOrder}>
							{strings.reprintOrders}
						</NavLink>
					</li>
					{this.renderMakeDonation()}
					{strings.navigationLinks.map((navigationLink, i) =>
						<NavigationLink
							key={i}
							navigationLink={navigationLink}
							toggleNav={this.props.toggleNav}
							toggleReprintOrder={this.props.toggleReprintOrder} />
					)}
					<li className='showtix-navigation__item'>
						<a className={"showtix-navigation__link"} target="_blank"
                            href="https://www.showtix4u.com/#contact"
						>
							{strings.contact}
						</a>
					</li>
					<li className='showtix-navigation__item'>
						<a className={"showtix-navigation__link"} target="_blank"
                            href="http://status.showtix4u.com"
						>
							ShowTix4U Status
						</a>
					</li>
					<li className="showtix-navigation__item">
                        <NavLink
                            className={"showtix-navigation__link title" + (this.state.isLegalOpen ? ' is-open' : '')}
                            to="#"
                            onClick={() => this.toggleSubnav()}
                        >
                            {strings.legal}
                        </NavLink>
                        <ul className={"showtix-navigation__sublist " + (this.state.isLegalOpen ? 'is-open' : '')}>
							{strings.navigationLinks2.map((navigationLink, i) =>
								<NavigationLink
									key={i}
									navigationLink={navigationLink}
									toggleNav={this.props.toggleNav}
									toggleReprintOrder={this.props.toggleReprintOrder} />
							)}
                        </ul>
                    </li>
					{/* <li className='showtix-navigation__item'>
						<NavLink className="showtix-navigation__link" onClick={this.toggleLanguage} to="#">
							{GetAppLanguage() === 'en' ? 'Français' : 'English'}
						</NavLink>
				</li> */}
				</ul>
			</div>
		);
	}
}

PatronNavigation.propTypes = {
    toggleNav: PropTypes.func,
    toggleReprintOrder: PropTypes.func,
    makeDonation: PropTypes.func
}

export default PatronNavigation;


// WEBPACK FOOTER //
// ./src/components/Navigation/PatronNavigation/PatronNavigation.js